<template>
  <div class="box box-info">
    <div class="p-field p-col-12 p-md-4">
      <label for="item">Item </label>
      <AutoComplete v-model="items" filterMatchMode='contains'
                    :suggestions="filteredItems" @complete="searchItem($event)"
                    field="name" ref="itm" :dropdown="true">
      </AutoComplete>
      <Button @click.prevent="searchItemStatement"
              class="p-button-raised" label="Search" icon="pi pi-search"/>
    </div>
    <div class="p-fluid p-formgrid p-grid">
      <div class="p-field p-col-12 p-col-12">
        <a href="#" @click.prevent="exportCSV()" v-if="this.itemInHistoryLists.length > 0">
          <img src="../../../../static/img/excel.png"
               style="height: 3.5em;width: 3.5em;float: right;margin-right: 4em;"/>
        </a>
        <DataTable
          :value="itemInHistoryLists"
          :paginator="true" ref="po"
          :rows="100" :filters="filters"
          :rowsPerPageOptions="[100,500,1000]"
          editMode="cell"
          class="p-datatable-responsive p-datatable-gridlines"
        >
          <Column header="S.N">
            <template #body="sl">
              {{ sl.index + 1 }}
            </template>
          </Column>

          <Column headerStyle="width: 16em" header="Miti" field="updatedNepaliDate" :sortable="true"
                  filterMatchMode="contains">
            <template #filter>
              <InputText type="text" class="p-column-filter" v-model="filters['updatedNepaliDate']"/>
            </template>
          </Column>
          <Column headerStyle="width: 16em" header="Date" field="updatedDate" :sortable="true"
                  filterMatchMode="contains">
            <template #filter>
              <InputText type="text" class="p-column-filter" v-model="filters['updatedDate']"/>
            </template>
          </Column>


          <Column headerStyle="width: 16em" header="Name" field="itemName" :sortable="true" filterMatchMode="contains">
            <template #filter>
              <InputText type="text" class="p-column-filter" v-model="filters['itemName']"/>
            </template>
          </Column>
          <Column header="Code" field="itemCode" :sortable="true" filterMatchMode="contains">
            <template #filter>
              <InputText type="text" class="p-column-filter" v-model="filters['itemCode']"/>
            </template>
          </Column>

          <Column header="Unit" field="unitName" :sortable="true" filterMatchMode="contains">
            <template #filter>
              <InputText type="text" class="p-column-filter" v-model="filters['unitName']"/>
            </template>
          </Column>


          <Column header="Store" bodyStyle="text-align: right" :sortable="true" field="warehouseName"
                  filterMatchMode="contains">
            <template #filter>
              <InputText type="text" class="p-column-filter" v-model="filters['warehouseName']"/>
            </template>
          </Column>
          <Column header="In Stock" bodyStyle="text-align: right" :sortable="true" field="inStockQty"
                  filterMatchMode="contains">
            <template #filter>
              <InputText type="text" class="p-column-filter" v-model="filters['inStockQty']"/>
            </template>
          </Column>
          <Column header="Closing Srock" bodyStyle="text-align: right" :sortable="true" field="closingStockQty"
                  filterMatchMode="contains">
            <template #filter>
              <InputText type="text" class="p-column-filter" v-model="filters['closingStockQty']"/>
            </template>
          </Column>
          <template #empty>No record found</template>
        </DataTable>
      </div>
    </div>
  </div>
</template>
<script>
import DataTable from 'primevue/datatable'
import Column from 'primevue/column'
import globalKey from '../../../store/globalKey'
import axios from 'axios'
import InputText from 'primevue/inputtext'
import Button from 'primevue/button'
import $ from 'jquery'
import AutoComplete from 'primevue/autocomplete'

export default {
  name: 'PosItemClosingStock',
  data() {
    return {
      dialogShow: false,
      itemId: '',
      loading: false,
      imageDialog: false,
      filters: {},
      inStock: 0,
      filteredItems: null,
      itemInHistoryLists: [],
      columnList: '',
      englishDateEnabled: true,
      fromDate: null,
      toDate: null,
      items: ''
    }
  },
  computed: {
    itemMasterListByItemType() {
      return this.$store.state.itemMaster.itemMasterListByItemType
    }
  },
  mounted() {
    this.columnNames()
    this.itemMasterListByItemTypes()
  },
  methods: {
    async searchItemStatement() {
      if (this.items === '' || this.items === null) {
        this.$toast.add({severity: 'warn', summary: '', detail: 'Please select at least one item!', life: 3000})
        return
      }
      let dat = {
        id: this.items.id
      }
      this.loading = true
      let resp = await this.$store.dispatch('loadStockInDetailsHistory', dat)
      this.loading = false
      if (resp.data.data.length <= 0) {
        this.$toast.add({severity: 'error', summary: '', detail: 'Sorry! No data available.', life: 10000})
        // this.purchaseInvoiceLists = []
      }
      this.itemInHistoryLists = resp.data.data
    },
    async itemMasterListByItemTypes() {
      await this.$store.dispatch('loadItemMasterListByItemType')
    },
    exportCSV() {
      let data = {
        columnList: this.columnList
      }
      axios({
        url: globalKey + '/fileDownload/excelReportAccount/' + this.$store.getters.organisationId + '/' + this.$store.getters.userId + '/Item List' + '/' + this.$store.getters.fyId + '/' + data.columnList,
        method: 'get',
        headers: {'Accept': 'application/vnd.ms-excel', 'Authorization': localStorage.token},
        responseType: 'blob'
      }).then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]), {type: response.data.type})
        const link = document.createElement('a')
        const contentDisposition = response.headers['content-disposition']
        let fileName = 'itemList.xlsx'
        if (contentDisposition) {
          const fileNameMatch = contentDisposition.match(/filename="(.+)"/)
          if (fileNameMatch.length === 2) {
            fileName = fileNameMatch[1]
          }
        }
        link.href = url
        link.setAttribute('download', fileName)
        document.body.appendChild(link)
        link.click()
        link.remove()
        window.URL.revokeObjectURL(url)
      })
    },
    columnNames() {
      for (let i = 0; i < this.$refs.po.columns.length; i++) {
        this.columnList += this.$refs.po.columns[i].header + ','
      }
    },
    reset() {
      this.itemInHistoryLists = []
      this.items = ''
      if (!this.$store.getters.englishDate || this.$store.state.isEnglishDateEnabled === 'false') {
        this.fromDate = this.$store.getters.nepaliNewDate
        this.toDate = this.$store.getters.nepaliNewDate
      } else {
        this.fromDate = new Date().toISOString().slice(0, 10)
        this.toDate = new Date().toISOString().slice(0, 10)
      }
    },
    setNepaliDate() {
      if (this.$store.getters.nepaliNewDate !== '') {
        this.fromDate = this.$store.getters.nepaliNewDate
        this.toDate = this.$store.getters.nepaliNewDate
      }
    },
    setEnglishDate() {
      this.fromDate = new Date().toISOString().slice(0, 10)
      this.toDate = new Date().toISOString().slice(0, 10)
    },
    checkEnglish() {
      if (this.$store.state.isEnglishDateEnabled === false || this.$store.state.isEnglishDateEnabled === 'false') {
        this.englishDateEnabled = true
        return
      } else {
        this.englishDateEnabled = false
        return
      }
    },
    nepaliDate() {
      $('#fromDate').nepaliDatePicker({
        ndpYear: true,
        ndpMonth: true,
        ndpYearCount: 10,
        disableBefore: this.$store.state.startDate,
        disableAfter: this.$store.state.endDate,
        onChange: () => {
          this.fromDate = $('#fromDate').val()
        }
      })
      $('#toDate').nepaliDatePicker({
        ndpYear: true,
        ndpMonth: true,
        ndpYearCount: 10,
        disableBefore: this.$store.state.startDate,
        disableAfter: this.$store.state.endDate,
        onChange: () => {
          this.toDate = $('#toDate').val()
        }
      })
    },
    searchItem(event) {
      setTimeout(() => {
        if (!event.query.trim().length) {
          this.filteredItems = [...this.itemMasterListByItemType]
        } else {
          this.filteredItems = this.itemMasterListByItemType.filter((item) => {
            return item.name.toLowerCase().startsWith(event.query.toLowerCase())
          })
        }
      }, 250)
    }
  },
  components: {
    DataTable,
    Column,
    InputText,
    Button,
    AutoComplete
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// stockInHistoryReport.vue?75bb3726